/**
 * Main Styling file for Footer Component
 *
 * @author Creator-Solutions -> Owen Burns
 */
import styled from "styled-components";

const FooterContainer = styled.div`
  width: 95vw;
  height: 10vh;
  margin-top: 35px;
  position: sticky;
  bottom: 0;
`;

const FooterInnerContainer = styled.div`
  width: 40vw;
  height: 10vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const FooterIcons = styled.div`
  width: 40vw;
  height: 5vh;
  justify-content: center;
  align-self: center;
  display: flex;
  flex-direction: row;
  img {
    width: 25px;
    height: 25px;
    margin-left: 10px;
  }

  a {
    align-self: center;
  }
`;

const FooterCopyright = styled.div`
  width: 40vw;
  height: 5vh;
  display: flex;
  justify-content: center;
`;

const CopyrightText = styled.p`
  font-size: 16px;
  color: #fff;
  align-self: center;
`;

export {
  FooterContainer,
  FooterCopyright,
  CopyrightText,
  FooterIcons,
  FooterInnerContainer,
};
